export default {"src":"/_next/static/media/heart.a81b5f61.svg","height":64,"width":92,"blurWidth":0,"blurHeight":0};